import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledOrderStatus = styled('div')`
  display: flex;
  justify-content: space-between;

  @media only screen and (max-width: ${breakpoints.md}px) {
    padding: 0;
    .arrow-right-big {
      display: none;
    }
  }
`;
